// export const baseUrl = "https://erp-qrm.vastedge.com/api";
// export const baseUrl = "http://35.212.107.59:3001";
export const baseUrl = "https://erp-hhs.vastedge.com/api";
// export const baseUrl = "http://localhost:3007";

export function buildQuery(query = {}) {
  let queries = Object.keys(query).map((k) => `${k}=${query[k]}`);
  return `?${queries.join("&")}`;
}
// http://35.212.107.59:3014/transactionTypesfilter?